import { useMemo } from "react";
import { useRouter } from "next/router";
import MainLayout from "@/Component/MainLayout";
import Breadcrumbs from "@/Component/Common/Breadcrumbs";
import DownloadNH from "@/Component/Common/DownloadNH";
import styles from "./TermsCondition.module.css";
import UaeTermsContent from "./UaeTermsContent";
import IndiaTermsContent from "./IndiaTermsContent";

export default function TermsCondition() {
  const router = useRouter();

  const isIndia = useMemo(() => {
    const path = (router.asPath || "").split("?")[0];
    return path === "/in" || path.startsWith("/in/");
  }, [router.asPath]);

  return (
    <MainLayout hideHeader>
      <Breadcrumbs />
      <div className={`${styles.nextTermscontainer} standard-padding`}>
        {isIndia ? <IndiaTermsContent /> : <UaeTermsContent />}
      </div>
      <DownloadNH />
    </MainLayout>
  );
}
